import { render } from "./RetentionRatesYearOnYearByProgram.vue?vue&type=template&id=af0f3bd0"
import script from "./RetentionRatesYearOnYearByProgram.vue?vue&type=script&lang=js"
export * from "./RetentionRatesYearOnYearByProgram.vue?vue&type=script&lang=js"
script.render = render

export default script